"use client";

import Link from "next/link";

import { ArrowLeft, Mail, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";

import { CONTACT_INFO, CONTACT_LINKS } from "@/shared/config/contact";
import { LandingHeader } from "@/widgets/landing/ui/landing-header";

export function AccountDeletionPageClient({ homeHref = "/" }: { homeHref?: string }) {
  const { t } = useTranslation();

  return (
    <div className="relative min-h-screen scroll-smooth bg-white text-slate-900 antialiased">
      <LandingHeader />
      <main className="px-6 py-16 sm:py-24">
        <article className="mx-auto max-w-xl">
          <Link
            href={homeHref}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-teal-600 transition-colors hover:text-teal-700"
          >
            <ArrowLeft className="size-4" />
            {t("landing.accountDeletion.backHome")}
          </Link>

          <h1 className="mt-6 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            {t("landing.accountDeletion.title")}
          </h1>
          <p className="mt-4 text-base leading-relaxed text-slate-600">{t("landing.accountDeletion.intro")}</p>

          <section className="mt-8 rounded-lg border border-slate-200 bg-slate-50 p-5">
            <h2 className="text-lg font-semibold text-slate-900">{t("landing.accountDeletion.unavailableTitle")}</h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              {t("landing.accountDeletion.unavailableMessage")}
            </p>
            <ul className="mt-4 flex flex-col gap-3">
              <li>
                <a
                  href={CONTACT_LINKS.email}
                  className="inline-flex items-center gap-2 text-sm font-medium text-teal-600 underline underline-offset-4 hover:text-teal-700"
                >
                  <Mail className="size-4" aria-hidden="true" />
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT_LINKS.phone}
                  className="inline-flex items-center gap-2 text-sm font-medium text-teal-600 underline underline-offset-4 hover:text-teal-700"
                >
                  <Phone className="size-4" aria-hidden="true" />
                  {CONTACT_INFO.phone}
                </a>
              </li>
            </ul>
          </section>
        </article>
      </main>
    </div>
  );
}
